<template>
  <div>
    <div id="tool">
      <template v-for="lottery in storeNewLottery">
        <el-button :key="lottery.key" :type="selected === lottery.key ? 'primary' : ''" size="mini" @click="selectLottery(lottery.key)">{{ lottery.name }}</el-button>
      </template>
    </div>
<!--    <el-button class="start-button" @click="startHandler" type="primary" :disabled="disableStart" size="large">{{-->
<!--        running ? '停止' : '开始'-->
<!--      }}</el-button>-->
    <button class="float-button cool-button" :disabled="disableStart" @click="startHandler">
      {{ running ? '停止' : '开始' }}
    </button>
  </div>
</template>

<script>

export default {
  props: {
    running: Boolean,
    closeRes: Function
  },
  computed: {
    config: {
      get() {
        return this.$store.state.config;
      }
    },
    storeNewLottery() {
      return this.$store.state.newLottery;
    },
    remain() {
      if (!this.selected) {
        return 0
      }
      const count = this.storeNewLottery.find(lottery => this.selected === lottery.key).count
      return count - (this.result[this.selected] ? this.result[this.selected].length : 0)
    },
    result() {
      return this.$store.state.result;
    },
    disableStart() {
      return this.$store.state.list.length === 0 || !this.selected
    },
  },
  data() {
    return {
      selected: '',
      listStr: ''
    };
  },
  watch: {
    showRemoveoptions(v) {
      if (!v) {
        this.removeInfo.type = 0;
      }
    }
  },
  methods: {
    selectLottery(key) {
      this.selected = key
    },
    onSubmit() {
      if (!this.selected) {
        this.$message.error('请选择抽奖项');
        return;
      }

      if (this.remain <= 0) {
        this.$message.error('剩余抽奖次数不足');
        return;
      }

      const lottery = this.storeNewLottery.find(lottery => this.selected === lottery.key);
      const data = {
        category: this.selected,
        num: lottery.num,
        remain: this.remain,
        allIn: lottery.allIn
      }

      this.$emit(
          'toggle',
          Object.assign({}, data)
      );
    },
    startHandler() {
      this.$emit('toggle');
      if (!this.running) {
        this.onSubmit()
      }
    }
  }
}
</script>
<style lang="scss">
#tool {
  position: fixed;
  width: 60px;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .el-button + .el-button {
    margin-top: 20px;
    margin-left: 0px;
  }
}

.float-button {
  position: fixed;
  top: 100px;
  right: 50px;
}

.cool-button {
  background: linear-gradient(to right, #ff9059, #ff5400);
  border: none;
  color: #ffffff;
  cursor: pointer;
  height: 70px;
  width: 70px;
  line-height: 70px;
  text-align: center;
  border-radius: 50%;
  font-size: 17px;
  transition: background-color 0.3s, transform 0.3s;
}

.cool-button:hover {
  background: linear-gradient(to right,#ff9059, #ff5400);
  transform: scale(1.5);
}

.cool-button:active {
  transform: scale(1);
}

.cool-button[disabled] {
  background: #ccc;
  cursor: not-allowed;
}

</style>
